import { Box, Typography } from "@mui/material";
import logo from "@src/shared/assets/logo_1.png";
import wave from "@src/shared/assets/header copy 2.png";
import {
  ResetPasswordStep1,
  ResetPasswordStep2,
  ResetPasswordStep3,
} from "@src/features/auth";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoveryPassword } from "@src/entities/login";

import styles from "./styles.module.scss";

export const ResetPasswordPage = () => {
  const [step, setStep] = useState(1);
  const [isAllFieldsReady, setIsAllFieldsReady] = useState(false);
  const [isDisabledBtn, setIsDisabledBtn] = useState<boolean>(false);
  const [remainingSeconds, setRemainingSeconds] = useState<number>(0);

  const { mutate: recoveryPassword } = useRecoveryPassword();
  const navigate = useNavigate();
  const [data, setData] = useState({
    email: "",
    code: "",
    password: "",
  });

  useEffect(() => {
    if (isAllFieldsReady) {
      recoveryPassword(
        { login: data.email, code: data.code, new_password: data.password },
        {
          onSuccess: () => {
            navigate("/login");
          },
        }
      );
    }
  }, [isAllFieldsReady]);

  useEffect(() => {
    const blockUntil = localStorage.getItem("blockUntilForReset");
    if (blockUntil) {
      const timeLeft = +blockUntil - Date.now();
      if (timeLeft > 0) {
        setIsDisabledBtn(true);
        setRemainingSeconds(Math.floor(timeLeft / 1000));
      } else {
        localStorage.removeItem("blockUntilForReset");
      }
    }
  }, []);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isDisabledBtn && remainingSeconds > 0) {
      interval = setInterval(() => {
        setRemainingSeconds((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setIsDisabledBtn(false);
            localStorage.removeItem("blockUntilForReset");
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [isDisabledBtn, remainingSeconds]);

  return (
    <Box className={styles.root}>
      <img src={wave} alt="wave" className={styles.wave} />
      <div className={styles.leftPanel}>
        {step === 1 && (
          <ResetPasswordStep1
            setStep={setStep}
            setData={setData}
            setIsDisabledBtn={setIsDisabledBtn}
            setRemainingSeconds={setRemainingSeconds}
            isDisabledBtn={isDisabledBtn}
            remainingSeconds={remainingSeconds}
          />
        )}
        {step === 2 && (
          <ResetPasswordStep2
            login={data.email}
            setStep={setStep}
            setData={setData}
          />
        )}
        {step === 3 && (
          <ResetPasswordStep3
            setStep={setStep}
            setIsAllFieldsReady={setIsAllFieldsReady}
            setData={setData}
          />
        )}
      </div>
      <Box className={styles.rightPanel}>
        <img src={logo} alt="logo" className={styles.logo} />
        <Typography className={styles.slogan}>
          Помощник по найму
          <br />
          сотрудников 24/7
        </Typography>
      </Box>
    </Box>
  );
};
